import React from 'react';

import Context from '../../../../context';

import { CustomIcon, TableNullData } from '../../../../components';
import { IAcademicYear } from '../../../../types/academicYear.interface';

type Props = {
  data: any;
};

// ? Dates arrive as ISO strings; the panel is Persian throughout, so they are shown on the Jalali calendar.
function toJalali(value?: string): string {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('fa-IR');
}

const Body: React.FC<Props> = ({ data }: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { setSelectedYear, setShowModal } = React.useContext(Context.AcademicYearScreen);
  const docs: IAcademicYear[] = data?.data?.result?.docs;

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onClickUpdate(academicYear: IAcademicYear): void {
    setSelectedYear!(academicYear);
    setShowModal!('UPDATE');
  }

  function onClickDelete(academicYear: IAcademicYear): void {
    setSelectedYear!(academicYear);
    setShowModal!('DELETE');
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  if (!docs || docs?.length <= 0) return <TableNullData />;

  return (
    <tbody id="academic-year-body-wrapper">
      {docs?.map((academicYear: IAcademicYear, index: number) => (
        <tr key={`academic-year-tr-${index}`}>
          <td className="table-text">{academicYear.name}</td>
          <td className="table-text">{academicYear.key}</td>
          <td className="table-text">{toJalali(academicYear.startAt)}</td>
          <td className="table-text">{toJalali(academicYear.endAt)}</td>
          <td className="table-text">{academicYear.isCurrent ? 'سال جاری' : '—'}</td>
          <td className="table-options-wrapper">
            <CustomIcon icon={'fas fa-pencil'}          type="primary" hoverTitle={'ویرایش'} onClick={() => onClickUpdate(academicYear)} />
            <CustomIcon icon={'fas fa-trash-can-xmark'} type="danger"  hoverTitle={'حذف'}    onClick={() => onClickDelete(academicYear)} />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default Body;
